import React, { FC, ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { IconS24Dealer24 } from '@is24/cosma-ui-icons'
import { InsertionFlowScreensProps } from '../../../../../@types/props-types'
import { TooltipTypes } from '../../../../../@types/types'
import { ScreenTooltip } from '../../../../common/display/screenTooltip/ScreenTooltip'
import { SCREEN_REALTOR_LEAD_ENGINE, SCREENS } from '../../../../../services/domain/wizardScreens'
import ScreenContainer from '../../../../common/containers/screenContainer/ScreenContainer'
import { ScreenLayout } from '../../../../common/containers/screenLayout/ScreenLayout'
import Checkbox from '../../../../common/inputs/checkbox/Checkbox'
import { AbstractScreenValidationResult } from '../../../../../@types/validation-types'

const screen = SCREENS[SCREEN_REALTOR_LEAD_ENGINE]
const property = 'conversionToLeadAllowed'

interface AdditionalRealtorLeadEngineProps {
  headerKey?: string
}

export const RealtorLeadEngine: FC<
  InsertionFlowScreensProps<AbstractScreenValidationResult> & AdditionalRealtorLeadEngineProps
> = ({ insertionData, onNavigate, onChange }) => {
  const { t } = useTranslation()
  const displayAppropriateTooltip = (tooltipType: TooltipTypes): ReactElement => {
    return <ScreenTooltip tooltipType={tooltipType} tooltipKey='tooltip.screens.realtorLeadEngine.sale' />
  }

  return (
    <ScreenContainer containerId={screen.id} screen={screen} onNavigate={onNavigate}>
      <ScreenLayout
        id={`${screen.id}-desk-tooltip`}
        headline={'wizard.screen.realtorLeadEngine.header'}
        screenName={screen.name}
        headerIcon={<IconS24Dealer24 />}
        deskTooltip={displayAppropriateTooltip(TooltipTypes.DESKTOP)}
        mobileTooltip={displayAppropriateTooltip(TooltipTypes.MOBILE)}
      >
        <p className='font-body-medium-bold margin-bottom-none'>
          {t('wizard.screen.realtorLeadEngine.conversionToLeadAllowed.label', 'Broker recommendations')}
        </p>
        <Checkbox
          id='conversion-to-lead-allowed'
          name={property}
          checked={!!insertionData.conversionToLeadAllowed}
          onChange={(name, checked) => onChange({ screen: screen.name, property: name }, checked)}
          label={t('wizard.screen.realtorLeadEngine.conversionToLeadAllowed.text')}
        />
      </ScreenLayout>
    </ScreenContainer>
  )
}
